export class Invoice {
    id: string;
  organization_id: string;
  branch_id: string;
  date_time: string;
  price_offer: string;
  customer_id: string;
  customer_type:string;
  customer_name:string;
  invoice_type:string;
  invoice_no:string;
  invoice_id:string;
  delegate_type:string;
  delegate_id:string;
  delegate_name: string;
  items_from_branch_id: string;
  year: any;


  total_free: string;
  customer_cash: string;
  paid: string;
  time: string;
  row_id: string;

  disc_type:string;
  disc_value:string;
  remain:string;
  import_date:string;
  type_country:string;

  inv_details:string;
  inv_payment_details:string;
  // cashier_operation:string
  // cashier_id:string


    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/pos/invoices/invoices.ts